import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "prod-list"
};
const _hoisted_2 = {
  key: 0,
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "选择商品", -1);

const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择");

const _hoisted_5 = {
  class: "list"
};
const _hoisted_6 = {
  class: "rule-setting"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("金额比例分账");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("固定金额分账");

const _hoisted_9 = {
  key: 0,
  class: "alert"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("strong", null, "请注意！该金额为订单中商品的客户销售金额。与团队进货价/销售价无关")], -1);

const _hoisted_11 = [_hoisted_10];

const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "alert"
}, "请按照您团队在系统中的层级结构设置分账规则，否则将会导致分账错误或未进行分账计算", -1);

const _hoisted_13 = {
  class: "header"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "参与分账的订单", -1);

const _hoisted_15 = {
  class: "checkbox-group"
};
const _hoisted_16 = {
  class: "main-checkbox"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 开票订单 ");

const _hoisted_18 = {
  class: "sub-checkboxes"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-left"
}, "(", -1);

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 订单金额结算订单 ");

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 预付金额结算订单 ");

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-right"
}, ")", -1);

const _hoisted_23 = {
  class: "checkbox-group"
};
const _hoisted_24 = {
  class: "main-checkbox"
};

const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 非开票订单 ");

const _hoisted_26 = {
  class: "sub-checkboxes"
};

const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-left"
}, "(", -1);

const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 订单金额结算订单 ");

const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 预付金额结算订单 ");

const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-right"
}, ")", -1);

const _hoisted_31 = {
  class: "setting-list"
};
const _hoisted_32 = {
  class: "setting-item"
};
const _hoisted_33 = {
  class: "item-header"
};
const _hoisted_34 = {
  class: "item-info"
};
const _hoisted_35 = {
  class: "setting-item"
};
const _hoisted_36 = {
  class: "item-header"
};
const _hoisted_37 = {
  class: "item-info"
};
const _hoisted_38 = {
  class: "setting-item"
};
const _hoisted_39 = {
  class: "item-header"
};
const _hoisted_40 = {
  class: "item-info"
};
const _hoisted_41 = {
  key: 0,
  class: "setting-info"
};

const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "wrapper red"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("strong", null, "优先顺序说明：")]), /*#__PURE__*/_createElementVNode("p", null, "当订单中商品金额不够完成或超出所有角色分账之和，在扣除平台服务费后按照优先顺序依次满足， 可能会出现部分角色未分账，金额不足，或超出分账金额情况")], -1);

const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "wrapper light"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" 案例1： "), /*#__PURE__*/_createElementVNode("strong", null, "部分角色未分账，部分角色分账金额不足场景")]), /*#__PURE__*/_createElementVNode("p", null, "设置阿莫西林商业公司分账 5 元，优先顺序 1；业务员分账 5 元，优先顺序 2；销售团队主体分账 5 元，优先顺序 3.当前订单中阿莫西林商品价格为 9 元，则商业公司分账 5 元，业务员分账 4 元，销售团队主体分账 0")], -1);

const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "wrapper light"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" 案例2： "), /*#__PURE__*/_createElementVNode("strong", null, "超出分账金额场景")]), /*#__PURE__*/_createElementVNode("p", null, "设置阿莫西林商业公司分账 5 元，优先顺序 1；业务员分账 5 元，优先顺序 2；销售团队主体分账 5 元，优先顺序 3. 当前订单中阿莫西林商品价格为 16 元，则商业公司分账 5 元，业务员分账 5元，销售团队主体分账 6 元")], -1);

const _hoisted_45 = [_hoisted_42, _hoisted_43, _hoisted_44];

const _hoisted_46 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_47 = /*#__PURE__*/_createTextVNode("确定");

import { ref, watch, computed, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
import ProdModal from './prod-modal';
export default {
  name: 'setting-update-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: [String, Number],
    merchandiseRelationId: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emits('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (!v) return;
      prodModal.selectedList = [];
      levelOneRuleConfig.value.forEach(item => {
        item.value = undefined;
        item.percent = undefined;
      });
      levelOneRuleConfig.value[0].sortIndex = 1;
      levelOneRuleConfig.value[1].sortIndex = 4;
      levelOneRuleConfig.value[2].sortIndex = 3;
      levelOneRuleConfig.value[3].sortIndex = 2;
      levelTwoRuleConfig.value.forEach(item => {
        item.value = undefined;
        item.percent = undefined;
      });
      levelTwoRuleConfig.value[0].sortIndex = 1;
      levelTwoRuleConfig.value[1].sortIndex = 5;
      levelTwoRuleConfig.value[2].sortIndex = 4;
      levelTwoRuleConfig.value[3].sortIndex = 3;
      levelTwoRuleConfig.value[4].sortIndex = 2;
      levelThreeRuleConfig.value.forEach(item => {
        item.value = undefined;
        item.percent = undefined;
      });
      levelThreeRuleConfig.value[0].sortIndex = 1;
      levelThreeRuleConfig.value[1].sortIndex = 6;
      levelThreeRuleConfig.value[2].sortIndex = 5;
      levelThreeRuleConfig.value[3].sortIndex = 4;
      levelThreeRuleConfig.value[4].sortIndex = 3;
      levelThreeRuleConfig.value[5].sortIndex = 2;
      invoiceSettings.mainChecked = false;
      invoiceSettings.orderAmount = false;
      invoiceSettings.preAmount = false;
      noInvoiceSettings.mainChecked = false;
      noInvoiceSettings.orderAmount = false;
      noInvoiceSettings.preAmount = false;

      if (props.merchandiseRelationId) {
        getDetail();
      }
    });
    const splitMethod = ref(2);
    const splitRuleName = computed(() => splitMethod.value === 1 ? '比例' : '金额');
    const levelOneRuleConfig = ref([{
      percent: undefined,
      value: undefined,
      sortIndex: 1,
      name: '商业公司'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 4,
      name: '销售团队主体'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 3,
      name: '一级团队分账受益人'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 2,
      name: '一级团队业务员/下单人'
    }]);
    const levelTwoRuleConfig = ref([{
      percent: undefined,
      value: undefined,
      sortIndex: 1,
      name: '商业公司'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 5,
      name: '销售团队主体'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 4,
      name: '一级团队分账受益人'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 3,
      name: '二级团队分账受益人'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 2,
      name: '二级团队业务员/下单人'
    }]);
    const levelThreeRuleConfig = ref([{
      percent: undefined,
      value: undefined,
      sortIndex: 1,
      name: '商业公司'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 6,
      name: '销售团队主体'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 5,
      name: '一级团队分账受益人'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 4,
      name: '二级团队分账受益人'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 3,
      name: '三级团队分账受益人'
    }, {
      percent: undefined,
      value: undefined,
      sortIndex: 2,
      name: '三级团队业务员/下单人'
    }]);
    const prodModal = reactive({
      show: false,
      selectedList: []
    });
    const prodNames = computed(() => {
      if (prodModal.selectedList.length) {
        return prodModal.selectedList.map(v => v.prodName).join();
      }

      return;
    }); // 开票订单设置

    const invoiceSettings = reactive({
      mainChecked: false,
      orderAmount: false,
      preAmount: false
    }); // 非开票订单设置

    const noInvoiceSettings = reactive({
      mainChecked: false,
      orderAmount: false,
      preAmount: false
    }); // 初始化设置

    function initInvoiceSettings(data) {
      console.log("data", data);

      if (data.invoiceSettmentType) {
        invoiceSettings.mainChecked = true;
        invoiceSettings.orderAmount = data.invoiceSettmentType.includes('1');
        invoiceSettings.preAmount = data.invoiceSettmentType.includes('2');
      } else {
        invoiceSettings.mainChecked = false;
        invoiceSettings.orderAmount = false;
        invoiceSettings.preAmount = false;
      }

      if (data.noinvoiceSettmentType) {
        noInvoiceSettings.mainChecked = true;
        noInvoiceSettings.orderAmount = data.noinvoiceSettmentType.includes('1');
        noInvoiceSettings.preAmount = data.noinvoiceSettmentType.includes('2');
      } else {
        noInvoiceSettings.mainChecked = false;
        noInvoiceSettings.orderAmount = false;
        noInvoiceSettings.preAmount = false;
      }
    } // 处理子选项变化


    function handleSubCheckboxChange(type) {
      const settings = type === 'invoice' ? invoiceSettings : noInvoiceSettings; // 根据子选项状态更新主选项

      settings.mainChecked = settings.orderAmount || settings.preAmount;
    }

    function removeProdHandle(item) {
      let targetIndex = prodModal.selectedList.findIndex(v => v.prodNo === item.prodNo);
      prodModal.selectedList.splice(targetIndex, 1);
    }

    function getDetail() {
      let params = {
        merchandiseRelationId: props.merchandiseRelationId
      };
      Axios.get('/admin/split/rule/getMerchandiseSplitRuleDetail.json', {
        params
      }).then(res => {
        let {
          success,
          data
        } = res.data;
        if (!success) return;
        prodModal.selectedList = data.prodInfoList;
        splitMethod.value = data.splitMethod;
        let levelOneData = data.levelOneRuleConfig || {};
        let levelTwoData = data.levelTwoRuleConfig || {};
        let levelThreeData = data.levelThreeRuleConfig || {};

        if (splitMethod.value == 1) {
          levelOneRuleConfig.value[0].percent = levelOneData.branchSplitValue;
          levelOneRuleConfig.value[1].percent = levelOneData.supplierSplitValue;
          levelOneRuleConfig.value[2].percent = levelOneData.levelOneSplitValue;
          levelOneRuleConfig.value[3].percent = levelOneData.salesmanSplitValue;
          levelTwoRuleConfig.value[0].percent = levelTwoData.branchSplitValue;
          levelTwoRuleConfig.value[1].percent = levelTwoData.supplierSplitValue;
          levelTwoRuleConfig.value[2].percent = levelTwoData.levelOneSplitValue;
          levelTwoRuleConfig.value[3].percent = levelTwoData.levelTwoSplitValue;
          levelTwoRuleConfig.value[4].percent = levelTwoData.salesmanSplitValue;
          levelThreeRuleConfig.value[0].percent = levelThreeData.branchSplitValue;
          levelThreeRuleConfig.value[1].percent = levelThreeData.supplierSplitValue;
          levelThreeRuleConfig.value[2].percent = levelThreeData.levelOneSplitValue;
          levelThreeRuleConfig.value[3].percent = levelThreeData.levelTwoSplitValue;
          levelThreeRuleConfig.value[4].percent = levelThreeData.levelThreeSplitValue;
          levelThreeRuleConfig.value[5].percent = levelThreeData.salesmanSplitValue;
        } else {
          levelOneRuleConfig.value[0].value = levelOneData.branchSplitValue;
          levelOneRuleConfig.value[1].value = levelOneData.supplierSplitValue;
          levelOneRuleConfig.value[2].value = levelOneData.levelOneSplitValue;
          levelOneRuleConfig.value[3].value = levelOneData.salesmanSplitValue;
          levelTwoRuleConfig.value[0].value = levelTwoData.branchSplitValue;
          levelTwoRuleConfig.value[1].value = levelTwoData.supplierSplitValue;
          levelTwoRuleConfig.value[2].value = levelTwoData.levelOneSplitValue;
          levelTwoRuleConfig.value[3].value = levelTwoData.levelTwoSplitValue;
          levelTwoRuleConfig.value[4].value = levelTwoData.salesmanSplitValue;
          levelThreeRuleConfig.value[0].value = levelThreeData.branchSplitValue;
          levelThreeRuleConfig.value[1].value = levelThreeData.supplierSplitValue;
          levelThreeRuleConfig.value[2].value = levelThreeData.levelOneSplitValue;
          levelThreeRuleConfig.value[3].value = levelThreeData.levelTwoSplitValue;
          levelThreeRuleConfig.value[4].value = levelThreeData.levelThreeSplitValue;
          levelThreeRuleConfig.value[5].value = levelThreeData.salesmanSplitValue;
        }

        if (levelOneData.branchSort || levelOneData.supplierSort || levelOneData.levelOneSort || levelOneData.salesmanSort) {
          levelOneRuleConfig.value[0].sortIndex = levelOneData.branchSort;
          levelOneRuleConfig.value[1].sortIndex = levelOneData.supplierSort;
          levelOneRuleConfig.value[2].sortIndex = levelOneData.levelOneSort;
          levelOneRuleConfig.value[3].sortIndex = levelOneData.salesmanSort;
        }

        if (levelTwoData.branchSort || levelTwoData.supplierSort || levelTwoData.levelOneSort || levelTwoData.levelTwoSort || levelTwoData.salesmanSort) {
          levelTwoRuleConfig.value[0].sortIndex = levelTwoData.branchSort;
          levelTwoRuleConfig.value[1].sortIndex = levelTwoData.supplierSort;
          levelTwoRuleConfig.value[2].sortIndex = levelTwoData.levelOneSort;
          levelTwoRuleConfig.value[3].sortIndex = levelTwoData.levelTwoSort;
          levelTwoRuleConfig.value[4].sortIndex = levelTwoData.salesmanSort;
        }

        if (levelThreeData.branchSort || levelThreeData.supplierSort || levelThreeData.levelOneSort || levelThreeData.levelTwoSort || levelThreeData.salesmanSort || levelThreeData.levelThreeSort) {
          levelThreeRuleConfig.value[0].sortIndex = levelThreeData.branchSort;
          levelThreeRuleConfig.value[1].sortIndex = levelThreeData.supplierSort;
          levelThreeRuleConfig.value[2].sortIndex = levelThreeData.levelOneSort;
          levelThreeRuleConfig.value[3].sortIndex = levelThreeData.levelTwoSort;
          levelThreeRuleConfig.value[4].sortIndex = levelThreeData.levelThreeSort;
          levelThreeRuleConfig.value[5].sortIndex = levelThreeData.salesmanSort;
        }

        initInvoiceSettings(data);
      });
    }

    function submit(noValid) {
      let body = {
        supplierId: props.supplierId,
        splitMethod: splitMethod.value
      };

      if (noValid !== 'noValid' && prodModal.selectedList.length === 0) {
        ElMessage.error('请选择商品');
        return;
      }

      if (body.splitMethod == '2') {
        let sortValid_1 = _validSort(levelOneRuleConfig.value);

        let sortValid_2 = _validSort(levelTwoRuleConfig.value);

        let sortValid_3 = _validSort(levelThreeRuleConfig.value);

        if (!(sortValid_1 && sortValid_2 && sortValid_3)) {
          ElMessage.error('分账优先顺序不可相同');
          return;
        }
      }

      body.prodInfoList = prodModal.selectedList.map(v => {
        return {
          prodNo: v.prodNo,
          prodName: v.prodName,
          branchId: v.branchId
        };
      });
      let levelOne = levelOneRuleConfig.value;
      let levelTwo = levelTwoRuleConfig.value;
      let levelThree = levelThreeRuleConfig.value;
      let isPercent = body.splitMethod == '1';
      body.levelOneRuleConfig = {
        branchSplitValue: isPercent ? _formateNumber(levelOne[0].percent) : _formateNumber(levelOne[0].value),
        branchSort: isPercent ? undefined : levelOne[0].sortIndex,
        supplierSplitValue: isPercent ? _formateNumber(levelOne[1].percent) : _formateNumber(levelOne[1].value),
        supplierSort: isPercent ? undefined : levelOne[1].sortIndex,
        levelOneSplitValue: isPercent ? _formateNumber(levelOne[2].percent) : _formateNumber(levelOne[2].value),
        levelOneSort: isPercent ? undefined : levelOne[2].sortIndex,
        salesmanSplitValue: isPercent ? _formateNumber(levelOne[3].percent) : _formateNumber(levelOne[3].value),
        salesmanSort: isPercent ? undefined : levelOne[3].sortIndex
      };
      body.levelTwoRuleConfig = {
        branchSplitValue: isPercent ? _formateNumber(levelTwo[0].percent) : _formateNumber(levelTwo[0].value),
        branchSort: isPercent ? undefined : levelTwo[0].sortIndex,
        supplierSplitValue: isPercent ? _formateNumber(levelTwo[1].percent) : _formateNumber(levelTwo[1].value),
        supplierSort: isPercent ? undefined : levelTwo[1].sortIndex,
        levelOneSplitValue: isPercent ? _formateNumber(levelTwo[2].percent) : _formateNumber(levelTwo[2].value),
        levelOneSort: isPercent ? undefined : levelTwo[2].sortIndex,
        levelTwoSplitValue: isPercent ? _formateNumber(levelTwo[3].percent) : _formateNumber(levelTwo[3].value),
        levelTwoSort: isPercent ? undefined : levelTwo[3].sortIndex,
        salesmanSplitValue: isPercent ? _formateNumber(levelTwo[4].percent) : _formateNumber(levelTwo[4].value),
        salesmanSort: isPercent ? undefined : levelTwo[4].sortIndex
      };
      body.levelThreeRuleConfig = {
        branchSplitValue: isPercent ? _formateNumber(levelThree[0].percent) : _formateNumber(levelThree[0].value),
        branchSort: isPercent ? undefined : levelThree[0].sortIndex,
        supplierSplitValue: isPercent ? _formateNumber(levelThree[1].percent) : _formateNumber(levelThree[1].value),
        supplierSort: isPercent ? undefined : levelThree[1].sortIndex,
        levelOneSplitValue: isPercent ? _formateNumber(levelThree[2].percent) : _formateNumber(levelThree[2].value),
        levelOneSort: isPercent ? undefined : levelThree[2].sortIndex,
        levelTwoSplitValue: isPercent ? _formateNumber(levelThree[3].percent) : _formateNumber(levelThree[3].value),
        levelTwoSort: isPercent ? undefined : levelThree[3].sortIndex,
        levelThreeSplitValue: isPercent ? _formateNumber(levelThree[4].percent) : _formateNumber(levelThree[4].value),
        levelThreeSort: isPercent ? undefined : levelThree[4].sortIndex,
        salesmanSplitValue: isPercent ? _formateNumber(levelThree[5].percent) : _formateNumber(levelThree[5].value),
        salesmanSort: isPercent ? undefined : levelThree[5].sortIndex
      };

      if (noValid === 'noValid') {
        body.skipSplitUserCheck = '1';
      }

      if (props.merchandiseRelationId) {
        body.merchandiseRelationId = props.merchandiseRelationId;
      } // 构建开票订单的值


      const invoiceValues = [];

      if (invoiceSettings.mainChecked) {
        if (invoiceSettings.orderAmount) invoiceValues.push('1');
        if (invoiceSettings.preAmount) invoiceValues.push('2');
      } else {
        invoiceValues.push('');
      } // 构建非开票订单的值


      const noInvoiceValues = [];

      if (noInvoiceSettings.mainChecked) {
        if (noInvoiceSettings.orderAmount) noInvoiceValues.push('1');
        if (noInvoiceSettings.preAmount) noInvoiceValues.push('2');
      } else {
        noInvoiceValues.push('');
      }

      body.invoiceSettmentType = invoiceValues.join(',');
      body.noinvoiceSettmentType = noInvoiceValues.join(',');

      _formate(body);

      Axios.post('/admin/split/rule/insertOrUpdateMerchandiseSplitRule.json', body).then(res => {
        let {
          msg,
          code,
          data
        } = res.data;

        if (code === 0) {
          if (!data) {
            ElMessage.error(msg);
            return;
          }

          let {
            popupType,
            message
          } = data;

          if (popupType === 2) {
            ElMessageBox.confirm(message, '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '去设置',
              distinguishCancelAndClose: true,
              type: 'warning'
            }).then(() => {
              submit('noValid');
            }).catch(action => {
              if (action === 'cancel') {
                let routeHref = router.resolve({
                  name: 'BusinessManage',
                  query: {
                    supplierId: props.supplierId,
                    storeType: 2,
                    from: 'ControlSalesTeam'
                  }
                }).href;
                window.open(routeHref, '_blank');
              }
            });
          } else if (popupType === 1) {
            ElMessageBox.confirm(message, '提示', {
              confirmButtonText: '去设置',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let routeHref = router.resolve({
                name: 'BusinessManage',
                query: {
                  supplierId: props.supplierId,
                  storeType: 2,
                  from: 'ControlSalesTeam'
                }
              }).href;
              window.open(routeHref, '_blank');
            }).catch(e => {});
          }
        } else {
          ElMessage.success('操作成功');
          emits('success');
          visible.value = false;
        }
      });
    }

    function _formate(body) {
      let levelOneLength = Object.keys(body.levelOneRuleConfig).every(key => !body.levelOneRuleConfig[key]);
      let levelTwoLength = Object.keys(body.levelTwoRuleConfig).every(key => !body.levelTwoRuleConfig[key]);
      let levelThreeLength = Object.keys(body.levelThreeRuleConfig).every(key => !body.levelThreeRuleConfig[key]);

      if (levelOneLength) {
        delete body.levelOneRuleConfig;
      }

      if (levelTwoLength) {
        delete body.levelTwoRuleConfig;
      }

      if (levelThreeLength) {
        delete body.levelThreeRuleConfig;
      }
    }

    function _formateNumber(v) {
      if (v === 0) return undefined;
      return v;
    }

    function _validSort(list) {
      let sortList = list.map(item => item.sortIndex).filter(Boolean);
      let uniqSortList = Array.from(new Set(sortList));

      if (sortList.length === uniqSortList.length) {
        return true;
      }

      return false;
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _isRef(visible) ? visible.value = $event : null),
        title: props.merchandiseRelationId ? '编辑分账商品' : '新增分账商品',
        width: "1300px",
        top: "5vh",
        "custom-class": "accountrule-update-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_46]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_47]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [!props.merchandiseRelationId ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _cache[0] || (_cache[0] = $event => prodModal.show = true)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prodModal.selectedList, item => {
          return _openBlock(), _createBlock(_component_el_tag, {
            key: item.prodNo,
            closable: !props.merchandiseRelationId,
            style: {
              "margin-right": "10px",
              "margin-bottom": "10px"
            },
            onClose: $event => removeProdHandle(item)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.prodName), 1)]),
            _: 2
          }, 1032, ["closable", "onClose"]);
        }), 128))])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_radio_group, {
          modelValue: splitMethod.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => splitMethod.value = $event)
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_radio, {
            label: 1,
            border: ""
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          }, 512), [[_vShow, false]]), _createVNode(_component_el_radio, {
            label: 2,
            border: ""
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), splitMethod.value == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true), _hoisted_12, _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_checkbox, {
          modelValue: invoiceSettings.mainChecked,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => invoiceSettings.mainChecked = $event),
          onChange: _cache[3] || (_cache[3] = $event => _ctx.handleMainCheckboxChange('invoice'))
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_el_checkbox, {
          modelValue: invoiceSettings.orderAmount,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => invoiceSettings.orderAmount = $event),
          onChange: _cache[5] || (_cache[5] = $event => handleSubCheckboxChange('invoice'))
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
          modelValue: invoiceSettings.preAmount,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => invoiceSettings.preAmount = $event),
          onChange: _cache[7] || (_cache[7] = $event => handleSubCheckboxChange('invoice'))
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        }, 8, ["modelValue"]), _hoisted_22])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_checkbox, {
          modelValue: noInvoiceSettings.mainChecked,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => noInvoiceSettings.mainChecked = $event),
          onChange: _cache[9] || (_cache[9] = $event => _ctx.handleMainCheckboxChange('noInvoice'))
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_el_checkbox, {
          modelValue: noInvoiceSettings.orderAmount,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => noInvoiceSettings.orderAmount = $event),
          onChange: _cache[11] || (_cache[11] = $event => handleSubCheckboxChange('noInvoice'))
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
          modelValue: noInvoiceSettings.preAmount,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => noInvoiceSettings.preAmount = $event),
          onChange: _cache[13] || (_cache[13] = $event => handleSubCheckboxChange('noInvoice'))
        }, {
          default: _withCtx(() => [_hoisted_29]),
          _: 1
        }, 8, ["modelValue"]), _hoisted_30])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, "一级团队分账" + _toDisplayString(_unref(splitRuleName)), 1), _createElementVNode("div", _hoisted_34, "当业务员所属一级团队，请设置商品分账" + _toDisplayString(_unref(splitRuleName)), 1), _createVNode(_component_el_table, {
          data: levelOneRuleConfig.value,
          "show-summary": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "分账参与方",
            prop: "name"
          }), splitMethod.value == '1' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "分账比例（%）",
            prop: "percent"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.percent,
              "onUpdate:modelValue": $event => scope.row.percent = $event,
              min: 0,
              max: 100,
              "controls-position": "right",
              precision: 2,
              style: {
                "width": "120px"
              }
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_table_column, {
            label: "分配金额",
            prop: "value"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.value,
              "onUpdate:modelValue": $event => scope.row.value = $event,
              min: 0,
              "controls-position": "right",
              style: {
                "width": "120px"
              },
              precision: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "优先顺序",
            width: "120"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row.sortIndex,
              "onUpdate:modelValue": $event => scope.row.sortIndex = $event,
              style: {
                "width": "90px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, i => {
                return _createVNode(_component_el_option, {
                  value: i,
                  key: i
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(i), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })], 64))]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, "二级团队分账" + _toDisplayString(_unref(splitRuleName)), 1), _createElementVNode("div", _hoisted_37, "当业务员所属二级团队，请设置商品分账" + _toDisplayString(_unref(splitRuleName)), 1), _createVNode(_component_el_table, {
          data: levelTwoRuleConfig.value,
          "show-summary": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "分账参与方",
            prop: "name"
          }), splitMethod.value == '1' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "分账比例（%）",
            prop: "percent"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.percent,
              "onUpdate:modelValue": $event => scope.row.percent = $event,
              min: 0,
              max: 100,
              "controls-position": "right",
              style: {
                "width": "120px"
              },
              precision: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_table_column, {
            label: "分配金额",
            prop: "value"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.value,
              "onUpdate:modelValue": $event => scope.row.value = $event,
              min: 0,
              "controls-position": "right",
              style: {
                "width": "120px"
              },
              precision: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "优先顺序",
            width: "120"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row.sortIndex,
              "onUpdate:modelValue": $event => scope.row.sortIndex = $event,
              style: {
                "width": "90px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, i => {
                return _createVNode(_component_el_option, {
                  value: i,
                  key: i
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(i), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })], 64))]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, "三级团队分账" + _toDisplayString(_unref(splitRuleName)), 1), _createElementVNode("div", _hoisted_40, "当业务员所属三级团队，请设置商品分账" + _toDisplayString(_unref(splitRuleName)), 1), _createVNode(_component_el_table, {
          data: levelThreeRuleConfig.value,
          "show-summary": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "分账参与方",
            prop: "name"
          }), splitMethod.value == '1' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "分账比例（%）",
            prop: "percent"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.percent,
              "onUpdate:modelValue": $event => scope.row.percent = $event,
              min: 0,
              max: 100,
              "controls-position": "right",
              style: {
                "width": "120px"
              },
              precision: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_table_column, {
            label: "分配金额",
            prop: "value"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.value,
              "onUpdate:modelValue": $event => scope.row.value = $event,
              min: 0,
              "controls-position": "right",
              style: {
                "width": "120px"
              },
              precision: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "优先顺序",
            width: "120"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row.sortIndex,
              "onUpdate:modelValue": $event => scope.row.sortIndex = $event,
              style: {
                "width": "90px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, i => {
                return _createVNode(_component_el_option, {
                  value: i,
                  key: i
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(i), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })], 64))]),
          _: 1
        }, 8, ["data"])])])]), splitMethod.value == '2' ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_45)) : _createCommentVNode("", true), _createVNode(_unref(ProdModal), {
          modelValue: prodModal.show,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => prodModal.show = $event),
          supplierId: props.supplierId,
          selectedList: prodModal.selectedList,
          onSuccess: _cache[16] || (_cache[16] = list => prodModal.selectedList = list)
        }, null, 8, ["modelValue", "supplierId", "selectedList"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};